import {
  setState,
  setEvents as setEventsCommon,
} from '@/store/common/mutations';
import { eventsService } from '@/services';

let store;

export default function (providers) {
  const { $api } = providers;

  store = store || {
    namespaced: true,
    state() {
      return {
        events: [],
        count: 0,
      };
    },
    // TODO, FIXIT - это копипаст из стора домашней страницы - сделать в одном месте
    mutations: {
      setState,
      setEvents(state, payload) {
        state.events = payload;
      },
      setCount(state, payload) {
        state.count = payload;
      },
    },
    actions: {
      init({ dispatch }, params) {
        return Promise.all([dispatch('getEvents', params)]);
      },
      async getEvents({ commit, rootState }, params) {
        if (params.municipality === '') {
          delete params.municipality;
        }

        const f = (data, count) => {
          commit('setEvents', data);
          commit('setCount', Number(count));
        };

        try {
          const { filtered, data } = await eventsService($api).getEvents(
            params,
          );

          f(data, filtered ? filtered : data.length);
        } catch (e) {
          f([], 0);
        }

        return Promise.resolve();
      },
    },
  };

  return store;
}



// WEBPACK FOOTER //
// ./src/pages/event/list/store.js